<script setup>
import { useDebounce } from '@/composables/useDebounce';
import { appConfig } from '@/lib/appConfig';
import { computed, ref, watch } from 'vue';


// getInitQuestions();

const openChat = ref(false);
const disabledQuestion = ref(false);
const questions = ref([]);
const messages = ref([]);
const chatFillRef = ref();

const searchQuery = ref('');
const debouncedQuery = useDebounce(searchQuery, 500);
const disabledSending = ref(false);
const chatClasses = computed(() => ['chat-content', { 'chat-content--open': openChat.value }]);

watch(debouncedQuery, triggerDebouncedQuery);

async function triggerDebouncedQuery(trigger) {
  if (!trigger.length) return;
  const url = new URL('/chat/search/trigger', appConfig.domain);
  url.search = new URLSearchParams({ trigger }).toString();
  try {
    const response = await fetch(url);
    const data = await response.json();
    questions.value = data;
  } catch (error) {
    console.log(error)
  }
}

function toggleChat() {
  openChat.value = !openChat.value;
}

async function sendQuestion() {
  try {
    disabledSending.value = true;
    const url = new URL('/chat/question', appConfig.domain);
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ question: searchQuery.value })
    });

    const data = await response.json();
    searchQuery.value = '';
    addMessageFromQuestion(data);
  } catch(error) {
    console.log(error)
  } finally {
    disabledSending.value = false;
  }
}

function addMessageFromQuestion({ question, answer, id }) {
  const existMessage = messages.value.find((m) => m.id === id);
  if (existMessage) return;

  disabledQuestion.value = true;
  messages.value.push({
    id,
    messages: question,
    user: true,
  });
  questions.value = questions.value?.filter((q) => q.id !== id);
  chatFillRef.value.scrollTop = chatFillRef.value.scrollHeight;
  searchQuery.value = '';

  setTimeout(() => {
    messages.value.push({
      id: answer + id,
      messages: answer,
      user: false,
    });
    chatFillRef.value.scrollTop = chatFillRef.value.scrollHeight;
    disabledQuestion.value = false;
  }, 200);
}

/* async function getInitQuestions() {
  const url = new URL('/chat', appConfig.domain);
  url.search = new URLSearchParams({ limit: 3 }).toString();

  const response = await fetch(url);
  const data = await response.json();

  questions.value = data.questions;
} */

function getMessageClasses(isUser) {
  return ['messages-element', { 'messages-element--user': isUser }];
}
</script>

<template>
  <Teleport to="body">
    <div class="chat">
      <div :class="chatClasses">
        <button class="close" @click="toggleChat">
          <img src="@/assets/img/close-new.svg" alt="" class="close__img">
        </button>
        <div ref="chatFillRef" class="chat-fill">
          <div class="greetings">
            <img src="@/assets/img/logo-small.svg" alt="" class="logo">
            <img src="@/assets/img/logo-text.svg" alt="" class="logo__text">
            <p class="greetings__title">Привет! <img src="@/assets/img/greetings-logo.png" alt=""
                class="greetings__title-logo"></p>
            <p class="greetings__text">Добро пожаловать, в чат послевыписки! Вот примеры вопросов которые ты можешь
              задать!</p>
          </div>
       <div v-if="questions.length" class="questions">
            <button
              v-for="q in questions"
              :key="q.id" class="questions__element"
              :disabled="disabledQuestion"
              @click="addMessageFromQuestion(q)"
            >
            {{ q.question }}
          </button>
          </div>
          <div v-if="messages.length" class="messages">
            <p
              v-for="m in messages"
              :key="m.id"
              :class="getMessageClasses(m.user)">
              {{ m.messages }}
            </p>
          </div>
   
        </div>
        <div class="chat-field">
          <input v-model="searchQuery" placeholder="Ваш вопрос" class="chat-field__input">
          <button :disabled="disabledSending || !searchQuery.length" class="chat-field__send" @click="sendQuestion">
            <img src="@/assets/img/send.svg" alt="" class="chat-field__send-icon">
          </button>
        </div>
      </div>
      <button class="chat__open" @click="toggleChat">
        <img src="@/assets/img/chat-icon.svg" alt="" class="chat__open-icon">
      </button>
    </div>
  </Teleport>
</template>

<style scoped>
.chat {
  position: fixed;
  z-index: 1111111111;
  right: 54px;
  bottom: 54px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
  pointer-events: none;

}

.chat__open {
  pointer-events: all;
}

.chat-content {
  max-width: 333px;
  width: 100%;
  box-shadow: 0 15px 80px 0 rgba(85, 85, 85, 0.17);
  background: #fff;
  border: 1px solid #ff2031;
  border-radius: 10px;
  padding: 16px;
  opacity: 0;
  transition: all 0.5s ease-in-out;
  transform: translateY(-40px);
  pointer-events: none;
}

.chat-content--open {
  transform: translateY(0);
  pointer-events: all;
  opacity: 1;
}

.chat-fill {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  max-height: 430px;
  overflow: auto;
  scrollbar-width: thin;
  gap: 8px;
}

.close {
  margin-left: auto;
  display: flex;
}

.greetings {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 21px;
}

.logo {
  width: 97px;
}

.logo__text {
  margin-top: 13px;
}

.greetings__title {
  margin-top: 16px;
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
  color: #100c40;
  display: flex;
  align-items: center;
  gap: 3px;
}

.greetings__text {
  margin-top: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  color: #9f9eb3;
}

.questions {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  background: #fff;
}

.questions__element {
  background: rgba(159, 158, 179, 0.09);
  border-radius: 8px;
  width: 100%;
  padding: 16px 17px;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  color: #77768f;
  transition: all 0.5s ease-in-out;
}

.questions__element:hover {
  color: #fff;
  background: #ff2031;
  opacity: 1;
}

.chat-field {
  margin-top: 8px;
  display: flex;
  gap: 8px;
}

.chat-field__input {
  border: 1px solid #cbcad5;
  border-radius: 8px;
  width: 100%;
  background: #fafafa;
  padding: 14px 19px;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
}

.chat-field__input::placeholder {
  color: #9f9eb3;
}

.chat-field__send {
  display: flex;
}

.messages {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.messages-element {
  opacity: 0;
  transform: translateY(10px);
  animation: fadeInUp 0.6s ease-out forwards;
  max-width: 90%;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #ff2031;
  font-size: 14px;
  line-height: 140%;
  color: #9f9eb3;
  word-break: break-word;
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.messages-element--user {
  margin-left: auto;
  text-align: right;
}
@media (max-height: 700px) {
  .chat{
    right: 16px;
  bottom: 16px;
  }
  .chat-fill{
    max-height: 55vh;
  }
}

@media (max-width: 768px) {
  .chat {
    right: 10px;
    bottom: 10px;
  }

  .chat-content {
    max-width: calc(100% - 10px);
  }

}
</style>